import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as reduxFormReducer } from 'redux-form';

import { reducer as cmsBanner } from 'features/Banners/CmsBanner/CmsBanner.reducer';
import { reducer as banners } from 'features/Banners/Banners.reducer';
import { reducer as products } from 'features/Products/Products.reducer';
import { reducer as searchBox } from 'features/Search/SearchBox/SearchBox.reducer';
import { reducer as searchMap } from 'features/Search/Map/SearchMap.reducer';
import { reducer as search } from 'features/Search/Search.reducer';
import { reducer as paymentMethods } from 'components/PaymentMethodSelector/PaymentMethodSelector.reducer';
import { reducer as cancel } from 'features/Settings/Membership/Cancel/Cancel.reducer';
import { reducer as dynamicTags } from 'components/DynamicTags/DynamicTags.reducer';
import { reducer as locationInput } from 'components/LocationInput/LocationInput.reducer';
import { reducer as vendor } from 'vendors/Vendor.reducer';
import { reducer as inventoryDetail } from 'features/InventoryDetail/InventoryDetail.reducer';
import { reducer as resetPassword } from 'features/ResetPassword/ResetPassword.reducer';

import entitityReducer from '../saga/entity-reducer';

import careers from './features/careers';
import homepage from './features/homepage';
import movement from './features/movement';
import phoneVerification from './features/phone-verification';
import checkout from './features/checkout';
import filterSetsReducer from './filtersets';
import page from './page';
import locale from './locale';
import modals from './modals';
import offer from './offer';
import user from './user';
import cart from './cart';
import device from './device';

import request from './request';
import error from './error';
import rating from './rating';

import video from './video';

export default combineReducers({
  routing: routerReducer,
  form: reduxFormReducer,
  filterSets: filterSetsReducer,

  features: combineReducers({
    careers,
    checkout,
    dynamicTags,
    homepage,
    inventoryDetail,
    locationInput,
    cancel,
    movement,
    paymentMethods,
    phoneVerification,
    products,
    resetPassword,
    search,
    searchBox,
    searchMap,
  }),

  entities: entitityReducer,

  // Core reducers
  banners,
  cart,
  cmsBanner,
  device,
  error,
  locale,
  modals,
  page,
  request,
  vendor,

  // Unsorted
  offer,
  rating,
  user,
  video,
});
